import getCollection from '../../../utils/db/getCollection'
import { GIFT_FUND_ITEMS_COLLECTION } from './giftFundConstants'
import { mapGiftFundItemFromDoc } from './mapGiftFundItem'

const getGiftFundItems = async () => {
  const docs = await getCollection({
    path: GIFT_FUND_ITEMS_COLLECTION,
    docIdName: 'id',
  })

  return (docs || []).map((doc) => mapGiftFundItemFromDoc(doc)).filter(Boolean)
}

export default getGiftFundItems
